export default __webpack_public_path__ + "static/media/information--pedestrians-permitted--g1.5f6c67bf.png";